export { avatarSizes, AvatarSize } from './avatar';
